export default __webpack_public_path__ + "static/media/mid-gard-logo.aad788ea.svg";